import React from 'react';
import DesignStepRequestPresenter from './DesignStepRequestPresenter';

const DesignStepRequestContainer = () => {
  return <DesignStepRequestPresenter />;
};

export default DesignStepRequestContainer;
